import { forwardRef } from "react";
import styled from "styled-components";
import Text from "../text";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function linearGradient(_ref) {
  let {
    theme
  } = _ref;
  const primary = theme.colors.primary.base;
  const secondary = theme.colors.secondary.base;
  return `${primary} linear-gradient(90deg, ${primary}, ${secondary})`;
}
function headerBackground(_ref2) {
  let {
    mode,
    theme
  } = _ref2;
  return mode === "dark" ? theme.colors.dark.bg : theme.colors.light.bg;
}
function titleColor(_ref3) {
  let {
    mode,
    theme
  } = _ref3;
  return mode === "dark" ? theme.colors.dark.heading : theme.colors.heading;
}
function dividerColor(_ref4) {
  let {
    mode,
    theme
  } = _ref4;
  return mode === "dark" ? theme.colors.dark.disabled : theme.colors.disabled;
}
const StyledCard = styled.div.withConfig({
  displayName: "brand-card__StyledCard",
  componentId: "sc-1dthkrx-0"
})(["overflow:hidden;border-radius:", "px;box-shadow:", ";"], p => p.theme.radii.base, p => p.theme.shadows.base);
const Header = styled.div.withConfig({
  displayName: "brand-card__Header",
  componentId: "sc-1dthkrx-1"
})(["display:flex;align-items:center;padding:24px ", "px;background:", ";"], p => p.theme.space.md, headerBackground);
const Bar = styled.div.withConfig({
  displayName: "brand-card__Bar",
  componentId: "sc-1dthkrx-2"
})(["height:", "px;background:", ";"], p => p.theme.space.xs, linearGradient);
const Logo = styled.div.withConfig({
  displayName: "brand-card__Logo",
  componentId: "sc-1dthkrx-3"
})(["display:inline-block;padding-right:", "px;margin-right:", "px;border-right:1px solid ", ";& > img{height:25px;}"], p => p.theme.space.md, p => p.theme.space.md, dividerColor);
const Title = styled(Text).withConfig({
  displayName: "brand-card__Title",
  componentId: "sc-1dthkrx-4"
})(["font-size:", "px;line-height:25px;font-weight:300;color:", ";"], p => p.theme.fontSizes.lg, titleColor);
const Content = styled.div.withConfig({
  displayName: "brand-card__Content",
  componentId: "sc-1dthkrx-5"
})(["padding:", "px;background-color:", ";"], p => p.theme.space.md, p => p.theme.colors.light.bg);
export const BrandCard = /*#__PURE__*/forwardRef((_ref5, ref) => {
  let {
    title,
    logo,
    alt,
    mode = "light",
    children,
    ...rest
  } = _ref5;
  return /*#__PURE__*/_jsxs(StyledCard, {
    ref: ref,
    ...rest,
    children: [/*#__PURE__*/_jsxs(Header, {
      mode: mode,
      children: [logo && /*#__PURE__*/_jsx(Logo, {
        mode: mode,
        children: /*#__PURE__*/_jsx("img", {
          src: logo,
          alt: alt
        })
      }), /*#__PURE__*/_jsx(Title, {
        mode: mode,
        ellipsis: true,
        children: title
      })]
    }), /*#__PURE__*/_jsx(Bar, {}), /*#__PURE__*/_jsx(Content, {
      children: children
    })]
  });
});
export default BrandCard;